import {PayPerUsePeriod} from '@dms/api/settings';

export const PAY_PER_USE_PERIODS: readonly PayPerUsePeriod[] = [
  'this_month',
  'last_30_days',
  'last_90_days',
];

export const DEFAULT_PAY_PER_USE_PERIOD: PayPerUsePeriod = 'this_month';

export const PAY_PER_USE_PERIOD_LABEL: Record<PayPerUsePeriod, string> = {
  this_month: 'general.labels.thisMonth',
  last_30_days: 'page.homepage.payPerUse.period.last30Days',
  last_90_days: 'page.homepage.payPerUse.period.last90Days',
};
